import axios from "axios";
import authHeader, { authHeaderDataForm } from "./authHeader";
import { base_url_api } from "../../config/keys";

const listPartners = async (page, searchValue = "") => {
  try {
    const response = await axios.get(
      `${base_url_api}/users?page=${page}&search=${searchValue}&roles=ROLE_PRESTATAIRE&order[nom]=asc`,
      { headers: authHeader() }
    );

    return response.data;
  } catch (error) {
    return error;
  }
};

const listPartnersLastInsert = async (page, searchValue = "") => {
  try {
    const response = await axios.get(
      `${base_url_api}/users?page=${page}&search=${searchValue}&roles=ROLE_PRESTATAIRE&order[id]=desc`,
      { headers: authHeader() }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};


const listPartnersByStatus = async (page, searchValue = "", status = "") => {
  try {
    let statusQuery = "";
    if (Array.isArray(status)) {
      // Add each status as a repeated parameter: &status=2&status=3
      statusQuery = status.map(s => `&status[]=${s}`).join("");
    } else if (status) {
      statusQuery = `&status=${status}`;
    }
    const response = await axios.get(
      `${base_url_api}/users?page=${page}&searchFirstLetter=${searchValue}&roles=ROLE_PRESTATAIRE${statusQuery}&order[nom]=asc`,
      { headers: authHeader() }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

const addPartner = async (data) => {
  try {
    const response = await axios.post(`${base_url_api}/users`, data);
    return response.data;
  } catch (error) {
    return error;
  }
};

const addAdminPartner = async (data) => {
  try {
    const response = await axios.post(`${base_url_api}/users`, data, {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

const editPartner = async (id, data) => {
  try {
    const response = await axios.put(
      `${base_url_api}/users/${id}`,
      {
        ...data,
      },
      { headers: authHeader() }
    );

    return response.data;
  } catch (error) {
    return error;
  }
};

const removePartner = async (id) => {
  try {
    const response = await axios.delete(`${base_url_api}/users/${id}`, {
      headers: authHeader(),
    });

    return response.data;
  } catch (error) {
    return error;
  }
};

const detailPartner = async (id) => {
  try {
    const response = await axios.get(`${base_url_api}/users/${id}`, {
      headers: authHeader(),
    });

    return response.data;
  } catch (error) {
    return error;
  }
};

const addFilesPartner = async (id, formData) => {
  try {
    const response = await axios.post(
      `${base_url_api}/user/${id}/files`,
      formData,
      {
        headers: authHeaderDataForm(),
      }
    );

    return response.data;
  } catch (error) {
    return error;
  }
};

const partnersService = {
  addPartner,
  addAdminPartner,
  editPartner,
  removePartner,
  detailPartner,
  listPartners,
  listPartnersByStatus,
  listPartnersLastInsert,
  addFilesPartner,
};

export default partnersService;
